module.exports = __webpack_public_path__ + "static/img/bg6.b53253a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg6.png
// module id = BtkB
// module chunks = 1